// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32xcl","delete":"styles_delete__3eVp2","update":"styles_update__1iW0x","add":"styles_add__2zMLo"};